import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import type { GetProps } from 'antd';

export function onlyNumbers(str:string|undefined) {
  if (!str) return "";
  return str.replace(/[^0-9]/g, "");
}

type RangePickerProps = GetProps<typeof DatePicker.RangePicker>;

export const disabledDate: RangePickerProps['disabledDate'] = (current) => {
  // Can not select days after today
  return current && current >= dayjs().endOf('day');
};

export function isAntesDoTermino(termino?: string) {
  if  (!termino) return true;
  return (new Date()).toISOString().split('T')[0] <= termino;
};

export function isStateValid(state: any) {
  if (!state) return false; // Makes sure it's not null
  if (typeof state !== "object") return false;
  if (typeof state.data !== "object") return false;
  return true;
}

export function isStateWithoutDataValid(state: any) {
  if (!state) return false; // Makes sure it's not null
  if (typeof state !== "object") return false;
  return true;
}

export function hasText(str: any) {
  if (!str) return false; // Makes sure it's not null
  else if (typeof str === "string") return str.trim().length > 0;
  else return true;
}
